import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, map, of } from "rxjs";
import { environment } from "../../../../../environments/environment";
import { Brand } from "../../../models/brand";
import { Dealer } from "../../../models/dealer";
import { Area } from "../../../models/area";
import { ProductData } from "../models/productData";
import { ProductConst } from "../models/productConst";
import { FavoriteFilter } from '../models/favoriteFilter';


@Injectable({
  providedIn: 'root'
})
export class FiltersApiService {
  constructor(private http: HttpClient) {
  }

  getBrands(): Observable<Brand[]> {
    return this.http.get<{ brands: Brand[] }>(`${environment.csibefrontend}v2/getProfilesEntities`).pipe(
      map(response => { return response.brands })
    )
  }

  getDealers(market: string, brands: string[], areeSales: string[], areeAfter: string[], dealerGroup?: string | null): Observable<Dealer[]> {
    let user = JSON.parse(localStorage.getItem('currentUser') || '{}');

    if (!!localStorage.getItem('sso') && !user.isInternal) {
      let userId = user.email;

      let params = new HttpParams()
        .append('userId', userId)
      return this.http.get<{ dealers: Dealer[] }>(`${environment.csibefrontend}v2/getDealersBySSOUser`, { params: params }).pipe(
        map(response => { return response.dealers.filter(x => brands.some(chr => x.name.startsWith(chr.toUpperCase()))) }));
    }
    else {
      let params = new HttpParams()
        .append('marketId', market)
        .append('brands', brands.toString())
        .append('areeSales', areeSales.toString())
        .append('areeAfter', areeAfter.toString());
      if (dealerGroup) {
        params = params.append('dealerGroup', dealerGroup)
      }
      return this.http.get<{ dealers: Dealer[] }>(`${environment.csibefrontend}v2/getDealersByMarket`, { params: params }).pipe(
        map(response => { return response.dealers }));
    }

  }

  getAreas(market: string, brands: string[]): Observable<{ areaSales: Area[], areaAfterSales: Area[] }> {
    const params = new HttpParams()
      .append('marketId', market)
      .append('brands', brands.toString());
    return this.http.get<{ areaSales: Area[], areaAfterSales: Area[] }>(`${environment.csibefrontend}v2/getAreasByMarket`, { params: params });
  }

  getProduct(brands: string[]): Observable<ProductData> {
    if (brands.length > 0) {
      return this.http.post<ProductData>(`${environment.csibefrontend}v2/getProductMachineTypesByBrands`, brands);
    }
    else return of({ brands: [] });
  }

  getProductConst() {
    return this.http.get<ProductConst>(`${environment.csibefrontend}v2/getMenuConstValues`);
  }

  getConstants() {
    return this.http.get(`${environment.csibefrontend}v2/getMenuConstValues`)//.pipe(tap(response => console.log(response)))
  }

  getSeriesNames(regions: string[], subregions: string[]) {
    const params = {
      regions: regions,
      subregions: subregions
    };
    return this.http.post<string[]>(`${environment.csibefrontend}v2/getSeriesNamesByRegionsCollection`, params);
  }

  getFavoriteFilter(filterName: string): Observable<FavoriteFilter[]> {
    const params = new HttpParams().append('filterName', filterName);
    return this.http.get<FavoriteFilter[]>(`${environment.csibefrontend}v2/getFavouritesFilter`, { params: params });
  }

  setFavoriteFilter(favoriteFilter: FavoriteFilter) {
    const params = new HttpParams().append('filterName', favoriteFilter.filterName);
    return this.http.post<FavoriteFilter>(`${environment.csibefrontend}v2/saveOrUpdateFavouritesFilter`, favoriteFilter.filter, { params: params });
  }

  deleteFavoriteFilter(filterName: string) {
    const params = new HttpParams().append('filterName', filterName);
    return this.http.delete<FavoriteFilter>(`${environment.csibefrontend}v2/deleteFavouritesFilter`, { params: params });
  }
}
